(() => {
  const header = document.querySelector('#shopify-header-section > .header');
  if (header && document.body.classList.contains('template-product')) {
    const measureHeader = () => document.documentElement.style.setProperty('--lcd-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    measureHeader();
    const headerSize = new ResizeObserver(measureHeader);
    headerSize.observe(header);
  }
  const previews = new WeakMap();
  function updateSummary(container) {
    const summary = container.querySelector('[data-lcd-variant-label]');
    if (!summary) return;
    const radioGroups = container.querySelectorAll('.product__variants variant-radios fieldset');
    const selected = radioGroups.length
      ? Array.from(radioGroups, group => group.querySelector('input:checked')?.value).filter(Boolean)
      : Array.from(container.querySelectorAll('.product__variants variant-selects select'), select => select.value);
    if (selected.length) summary.textContent = selected.join(' / ');
  }
  function changePhoto(input) {
    const field = input.closest('[data-lcd-photo-field]');
    const status = field.querySelector('[data-lcd-photo-status]');
    const preview = field.querySelector('[data-lcd-photo-preview]');
    const previous = previews.get(input);
    if (previous) URL.revokeObjectURL(previous);
    previews.delete(input);
    preview.hidden = true;
    preview.removeAttribute('src');
    status.textContent = '';
    input.setCustomValidity('');
    const file = input.files?.[0];
    if (!file) return;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
      input.value = '';
      input.setCustomValidity(input.dataset.photoError);
      status.textContent = input.dataset.photoError;
      input.reportValidity();
      return;
    }
    const url = URL.createObjectURL(file);
    previews.set(input, url);
    preview.src = url;
    preview.hidden = false;
    status.textContent = `${file.name} — ${input.dataset.photoSelected}`;
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-lcd-photo-field] input[type="file"]')) changePhoto(event.target);
    const container = event.target.closest('[id^="main-product--"], .product-section');
    if (container) updateSummary(container);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
    }
  }, true);
  function initialise(root) {
    root.querySelectorAll('[data-lcd-variant-summary]').forEach(summary => {
      const container = summary.closest('[id^="main-product--"], .product-section');
      if (container) updateSummary(container);
    });
    root.querySelectorAll('sticky-atc').forEach(sticky => {
      const container = sticky.closest('.shopify-section');
      if (!container) return;
      const size = new ResizeObserver(entries => container.style.setProperty('--lcd-sticky-height', `${entries[0].target.getBoundingClientRect().height}px`));
      size.observe(sticky);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();


// Keep explicit variant links in sync with the app's required option controls.
(() => {
  if (!document.querySelector('.lcd-variant-guide')) return;
  const requestedId = new URL(window.location.href).searchParams.get('variant');
  if (!requestedId) return;
  let finished = false;
  let queued = false;
  let observer;
  let stopTimer;
  const stop = () => {
    finished = true;
    observer?.disconnect();
    clearTimeout(stopTimer);
    document.removeEventListener('change', onManualChoice, true);
  };
  function onManualChoice(event) {
    if (event.isTrusted && event.target.matches('input[data-globoswatchindex]')) stop();
  }
  function syncRequestedVariant() {
    queued = false;
    if (finished) return;
    const data = document.querySelector('[id^="VariantJson-"]');
    const container = document.querySelector('.product__variants');
    if (!data || !container || !container.querySelector('[data-gsw-dropdown-bound="true"]')) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    const variant = variants.find(item => String(item.id) === requestedId);
    if (!variant || !Array.isArray(variant.options)) { stop(); return; }
    const inputs = variant.options.map((value, index) =>
      Array.from(container.querySelectorAll('input[data-globoswatchindex="option' + (index + 1) + '"]'))
        .find(input => input.value === value)
    );
    if (inputs.some(input => !input || input.disabled)) return;
    inputs.forEach(input => { if (!input.checked) input.click(); });
    if (inputs.every(input => input.checked)) stop();
  }
  function scheduleSync() {
    if (!finished && !queued) {
      queued = true;
      setTimeout(syncRequestedVariant, 0);
    }
  }
  observer = new MutationObserver(scheduleSync);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-gsw-dropdown-bound'] });
  document.addEventListener('change', onManualChoice, true);
  stopTimer = setTimeout(stop, 45000);
  scheduleSync();
})();


// Add a guide's exact variant without navigating or submitting twice.
(() => {
  const pending = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.lcd-guide-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form)) return;
    const button = form.querySelector('.lcd-guide-add');
    if (!button || button.disabled) return;
    pending.add(form);
    const original = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Ajout…';
    let status = form.querySelector('.lcd-guide-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'lcd-guide-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.style.cssText = 'font-size:12px;line-height:1.4;margin:6px 0 0;text-align:center';
      form.appendChild(status);
    }
    status.textContent = '';
    try {
      const body = new FormData(form);
      body.delete('return_to');
      body.set('quantity', '1');
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json' }, body
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Ajout impossible. Réessayez.');
      button.textContent = 'Ajouté ✓';
      status.textContent = 'Ce modèle a été ajouté au panier.';
      document.dispatchEvent(new CustomEvent('updateCart'));
    } catch (error) {
      button.textContent = original;
      status.textContent = error.message || 'Ajout non confirmé. Vérifiez votre panier avant de réessayer.';
    } finally {
      setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = original;
        pending.delete(form);
      }, 1200);
    }
  }, true);
})();
